var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.476868,
    y: 0.773926,
    width: 35.9803,
    height: 36.0048,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_337",
    transform: "matrix(0.0111111 0 0 0.0111036 0 0.000339198)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_337",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE7UlEQVR4nO2cWYhcRRSGKxrFFZcQJ9N9zr19TndiaNBEOvfUnXG0EcQFRQQxaCAGQRE3fPDJF1HwJYjBiE8iuEQMasiDElEQFBSjDyouD4JGnYSgmETELYkm01LTMwix7dy5i1X3dn1wHmdu/f/UnKo6tSjl8Xg8Ho/H4/F4PKNCp9M5SYLGeo38hkbaJ8gHBPkFqbfAdtsqg2DjCg20SyP3jg0B/m5ijM+z3cayc4IG3qSRZwaZrOfNRtpqu6Glpd1unyzI24YZrP+JGUG6xHabS8eNSp0owC8lNLnXD/q8q7qLbbe9VGikjQszmefjTtttLw0S8DXHy8lDevX+GOBc2xqcpzM+fpoG/iZlb+7NxZO2dTiPID2Q0eSeIB+JgS+wrcXtWQbw3qxG6/50723bepwlgsaVeZis5yLGxlrbmpxEgB7P02iNPG1yvm1dziHA7+ZsdE8jPWxbl3No4O/zNlqAD0oQkG1tTiFAh/Lv0WxmIdtsa3MKQf6jCKM1cs8MtLb1OYNZ1RVltAb6wtdB5hDkDwszGrkXA91mtys5giBvKdJoDfSWbY1OIEB3F2m0AH1sW6MTRDVaUajRyE/Z1ugMOVTueoNNpr8kaLVt63MGjfRQMfmZN9nW5hRrak00Zc58czP/0GE+y7Y25xCkHbkaHTTW29bkJBNBczLHmcZ7SqlFtjU5iwZ+M4dZxpGoFq62rcVppB7GOfTop23rKAUa6cUsRscBX2xbQynoBMG4Bv45/SAY+Dp0UmJo3pu+VzeuK7QnVO5oWOqqHr1vft62htIwia2mIP2S0uyNtttfKnS9cXvqFAJ8q+32lwoN/HK6RQsfjIHEdvtLQ1RbuUSAv02ZQvaYWYxtDaVB6o1VGvn3VD0b+bOpIDjHtobSEAGvy7CQ2Xnh2NjptjWUBgF+LMPg+JrfEU+IMap/DY5Tmk3P+apeQiaXnH+m2XBNa7YgPeHNTkgnCMbTz0RmB8gt5qJo0u+NNDE0W4L0Y5ac7Y/3JkQjT2U5u2eODK8Kw7OL7RIVQdf5ag10OEMa+XQSsZbm2+bOjAA9Y874mWsdpmRQ6ZmNQPN6DfRnhp69dyHLdfNfIECbzbmRAb/vS/PHV1VF1+mG/xCe0Gw6FCFvOM5nFgk2bzFHGZKMAWuC5ayqSIS8QSMfTT1A9g3fPKiePRG2LjK76wsbcOmw+X3dpe0zVNUQ5Duymm2W7LPpqM7Lpd68TAM9m/GAz3Qlb4tFwOuypJGiQpDfMQUyVSVibKzNMkAWGEc18PNTy1pLVVWIArrWbAA4YO6/ezfwTxr5vsrsb8bQvKrIC0k5xCcRNC5VFVpBHnDA1GEv6WytxBtRE2G4Mksh6n+K6Uq8ftaZrfrRRw4YOrSyqKpSz9ZZNg8KD9qnqkJXdRdn2hYr1uj9qmpo4Js08m9upQ7aoapIVAtXuzRICvDNqsqHdDTSdusmI31V6Xr2PLMlUKRfLRk9Y95iVaOCNhU75A8sGP2oGs2nO+meLDcPFhTAr5iHb9WoEoXhMlNpS//CZJKg7d0wPMW2VieIgUSQXs89JwM/MtI9edj1PAF+NfN1aqBd/hmiBJjCjwA/KEBfLzBN7NZA98cApyb5jueYE1Ma6K65XL7T7JCbon6/sE+7zXkPs9yPA7rcH0PzeDwej8fj8Xg8Ho/H41ED+RuxKeyV19/kIQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDark);
export default __webpack_public_path__ + "static/media/phone-dark.bdeb92ade65edd90048bc499346f6fd0.svg";
export { ForwardRef as ReactComponent };